<template>
  <div id="container">
    <div class="common_text">
      <div class="content">
        <div class="text_con">
          <div class="text_details">
            <div class="text_main">
              <input type="hidden" id="url" value="${url}" />
              <input type="hidden" id="filetoken" value="${filetoken}" />
            </div>
          </div>
          <div class="clear"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import aliyun from '../aliyun-web-office-sdk-1.1.2.min.js'
export default {
  name: 'FilePreview',
  computed: {
  },
  data () {
    return {
      data: null
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      const session = JSON.parse(sessionStorage.getItem('vuex'))
      if (session && session.login2 && session.login2Data) {
        for (let index = 0; index < session.login2Data.FileList.length; index++) {
          const file = session.login2Data.FileList[index]
          if (file.FileId.toString() === this.$route.query.id.toString()) {
            this.data = file
            document.title = this.data.FileName
            if (this.data.AliToken === '-1') {
              alert('您的文件名中包含特殊字符（如：+.....）导致无法预览，请去掉后再重试。')
              window.close()
            } else {
              if (this.data.FilePreViewUrl.length > 0) {
                // eslint-disable-next-line no-undef
                var demo = aliyun.config({
                  url: this.data.FilePreViewUrl,
                  mount: document.querySelector('#text_main')
                })
                demo.setToken({ token: this.data.AliToken })
              } else {
                alert('当前文档历史较悠久，不支持在线预览^_^')
                window.close()
              }
            }
            break
          }
        }
      }
    }
  }
}
</script>
